import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { ENTITY_BADGE_CLASSES, ENTITY_TYPE_LABELS } from "../../constants/entities";
import type { Interaction } from "../../hooks/useSandboxPersonas";
import type { SandboxEntityType } from "../../types/entities";
import { findNearestEntities } from "../../utils/embeddingUtils";

interface NearestEntitiesProps {
  userEmbedding: number[];
  interactions: Interaction[];
}

export function NearestEntities({ userEmbedding, interactions }: NearestEntitiesProps) {
  const interactionEntities = interactions.map((i) => ({
    ...i.entity,
    entityType: i.entityType,
  }));
  const unique = [
    ...new Map(interactionEntities.map((e) => [e.id, e])).values(),
  ];
  const nearest = findNearestEntities(userEmbedding, unique, 5);

  if (nearest.length === 0) return null;

  return (
    <section className="space-y-3">
      <h3 className="text-sm font-semibold">Most similar interactions</h3>
      <ul className="space-y-2">
        {nearest.map((entity, idx) => (
          <li key={entity.id} className="flex items-center gap-2 text-sm">
            <span className="w-4 text-xs tabular-nums text-muted-foreground">
              {idx + 1}.
            </span>
            <Badge
              variant="outline"
              className={cn(
                "shrink-0 text-xs capitalize",
                ENTITY_BADGE_CLASSES[entity.entityType as SandboxEntityType],
              )}
            >
              {ENTITY_TYPE_LABELS[entity.entityType as SandboxEntityType]}
            </Badge>
            <span className="flex-1 truncate">{entity.name}</span>
            <span className="shrink-0 text-xs font-medium tabular-nums text-muted-foreground">
              {(entity.similarity * 100).toFixed(1)}%
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
